/**
 * Redux store wrapper
 **/

import * as React from "react";
// eslint-disable-next-line no-restricted-imports -- react-redux Provider is needed for Redux integration
import {Provider as WrappedProvider} from "react-redux";

import {Server} from "@khanacademy/wonder-blocks-core";

import {createStore} from "./store.ts";

type Props = JSX.LibraryManagedAttributes<
    typeof WrappedProvider,
    React.ComponentProps<typeof WrappedProvider>
>;

/**
 * react-redux assumes that the presence of a DOM implies that we
 * aren't SSR-ing.  This isn't true for us since we use JSDOM to
 * SSR things.  This wrapper, wraps a custom version of react-redux
 * which adds an `ssr` prop to `Provider` to override react-redux's
 * SSR check.
 */
export const Provider: (props: Props) => React.ReactElement = (props) => {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return <WrappedProvider {...props} ssr={Server.isServerSide()} />;
};

interface StoreProviderProps {
    children?: React.ReactElement<any>;
}

const StoreProvider = (props: StoreProviderProps): React.ReactElement => {
    const {children} = props;

    return <Provider store={createStore()}>{children}</Provider>;
};

export default StoreProvider;
